import React, { useEffect, useState, useContext } from "react";
import AsyncSelect from "react-select/async";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import SessionsApi from "../Classes/API/Administration/SessionsApi";
import searchSessionsReq from "../Classes/Models/Requests/Administration/CreateSessionReq";
import "./style.scss";
import { LanguageContext } from "App";
import translations from "layouts/Appointments/Feedback/translations";

const SessionSelector = ({ setSession, Patient }) => {
  const [SessionsSearch, setSessionsSearch] = useState();
  const { translations } = useContext(LanguageContext);

  // const [OptionSelect, setOptionSelect] = useState([]);

  const [OptionSelect2, setOptionSelect2] = useState([]);

  useEffect(() => {
    GetSessions(true).then((res) => {
      setOptionSelect2(res);
    });
  }, [Patient]);

  // useEffect(() => {
  //   if (Patient) {
  //     let optionsArr = [];
  //     Patient.getPatient.sessions.forEach((item) => {
  //       optionsArr.push({ value: item, label: item.name });
  //     });
  //     setOptionSelect(optionsArr);
  //   }
  // }, [Patient]);
  const GetSessions = async (inputValue = "", supressError = false) => {
    if (Patient != null) {
      let searchReq = new searchSessionsReq();

      if (inputValue) {
        searchReq.Name = inputValue;
      }
      const hasPatient =
        Patient && Patient.getPatient && Object.keys(Patient.getPatient).length > 0;
      if (hasPatient) {
        searchReq.ContractId = Patient.getPatient.contractId;
        searchReq.IsContractSession = !!Patient.getPatient.contractId;
      }

      console.log(searchReq);

      let res = await SessionsApi.SearchSessions(searchReq);

      if (res.status == "Success") {
        let optionsArr = res.data.list.map((item) => ({
          value: item,
          label: item.name,
        }));

        return optionsArr;
      }
    }
    return [];
  };
  return (
    <div>
      <MDTypography variant="button" fontWeight="regular" color="danger" width="200px">
        {translations.SelectSession}
        <div className="select-session-dropdown">
          <AsyncSelect
            isClearable={true}
            loadOptions={(inputValue) => GetSessions(inputValue)}
            // defaultOptions={OptionSelect}
            defaultOptions={OptionSelect2}
            onInputChange={setSessionsSearch}
            onChange={(e) => setSession(e ? e.value : "")}
            // value={TypeId}
          />
        </div>
      </MDTypography>
    </div>
  );
};

export default SessionSelector;
